import styled from "styled-components";

export const StyledError404 = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;

  & img {
    width: auto;
    max-width: 780px;
  }

  & p {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 110%;

    color: #A1ABC9;

  }
`
export const TextError = styled.div`
  padding-top: 90px;
  text-align: center;
`